import React from "react";
import {
  FaUsers,
  FaCalendarAlt,
  FaBriefcase,
  FaExclamationTriangle,
  FaUserCheck,
} from "react-icons/fa";

interface StatsCardsProps {
  stats: {
    totalStudents: number;
    activatedStudents: number;
    notActivatedStudents: number;
    todayCompliant: number;
    totalApplicationsToday: number;
    studentsWithMissedDays: number;
  };
}

const StatsCards: React.FC<StatsCardsProps> = ({ stats }) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-5 gap-6 mb-8">
      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center">
          <FaUsers className="h-8 w-8 text-blue-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Total Students</p>
            <p className="text-2xl font-semibold text-gray-900">
              {stats.totalStudents}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center">
          <FaUserCheck className="h-8 w-8 text-green-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Activated</p>
            <p className="text-2xl font-semibold text-gray-900">
              {stats.activatedStudents}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center">
          <FaCalendarAlt className="h-8 w-8 text-purple-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Today Compliant</p>
            <p className="text-2xl font-semibold text-gray-900">
              {stats.todayCompliant}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center">
          <FaBriefcase className="h-8 w-8 text-cyan-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">Apps Today</p>
            <p className="text-2xl font-semibold text-gray-900">
              {stats.totalApplicationsToday}
            </p>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-lg shadow p-6">
        <div className="flex items-center">
          <FaExclamationTriangle className="h-8 w-8 text-red-600" />
          <div className="ml-4">
            <p className="text-sm font-medium text-gray-600">
              With Missed Days
            </p>
            <p className="text-2xl font-semibold text-gray-900">
              {stats.studentsWithMissedDays}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatsCards;
